export const mutations = {
  MutationSetAlertMessage(state, input) {
    state.alertMessage = input.alertMessage ? input.alertMessage : null;
    state.typeMessage = input.typeMessage;
    state.id = input.id ? input.id : null;
    state.typeUpload = input.typeUpload ? input.typeUpload : null;
    state.date = new Date();
  },
  MutationResetAlertMessage(state) {
    state.alertMessage = null;
    state.typeMessage = null;
    state.id = null;
    state.typeUpload = null;
    state.date = null;
  },
};
